// Modules
import moment from "moment";

// Constants
import { REVIEW_RETRO_CLAIM_FORM as Constants } from "constants/global";

export const validateReviewClaim = async (receiptDatetime?: string, netAmount?: number, configData = 14) => {
	const addDays = moment(receiptDatetime).add(configData, "days").valueOf();
	const dateToday = moment().valueOf();
	const errorMessageArray: Array<string> = [];
	if (netAmount && netAmount < Constants.NET_AMOUNT_LIMIT) {
		errorMessageArray.push(Constants.NET_AMOUNT_ERROR);
	}
	if (dateToday > addDays) {
		errorMessageArray.push(Constants.RECEIPT_DATETIME_ERROR);
	}
	return errorMessageArray;
};
